<dx-date-range-box
  class="date-range-box"
  [startDateLabel]="startDateLabel()"
  [endDateLabel]="endDateLabel()"
  [showClearButton]="true"
  (onValueChanged)="onValueChanged($event)"
  width="275"
  [height]="height"
  [(value)]="selectedDates"
>
</dx-date-range-box>
